module.exports = __webpack_public_path__ + "static/media/ca.eafc3786.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/ca.svg
// module id = 1436
// module chunks = 0